<div class="wil-content wilcity-archive">
    <section class="wil-section has-page-heading">
        <div class="container news-lists">
            <h1 class="heading_title__1bzno text-center">Finance</h1>

            <div class="row cleared lead-alpha">
                <div *ngIf="totalItems == 0" class="alert_module__Q4QZx" style="margin: 30px 0;">
                    <div class="alert_content__1ntU3">Sorry, We found no posts matched what are you looking for
                        ...</div>
                </div>

                <div *ngIf="totalItems > 0">
                    <div *ngFor="let item of finance; let i = index" class="">
                        <article class="col-xs-12 col-md-6 mb-30">
                            <div class="div-admission-image">
                                <a href="{{ siteUrl + '/finance/details/' + item.slug }}"
                                    class="tribe-events-calendar-list__event-featured-image-link">
                                    <img src="{{ item.featured_image | imageSrc : 'finance' : 'medium' }}"
                                        class="tribe-events-calendar-list__event-featured-image">
                                </a>
                            </div>

                            <div class="admission-section-content">

                                <h3 class="title-ellipsis-2">
                                    <a href="{{ siteUrl + '/finance/details/' + item.slug }}" title="{{ item.title }}"
                                        class="">
                                        {{ item.title }} </a>
                                </h3>

                                <!-- <div
                                    class="tribe-events-calendar-list__event-description tribe-common-b2 tribe-common-a11y-hidden">
                                    {{ item.content | excerpt : 60 }}
                                </div> -->

                            </div>
                        </article>

                        <div *ngIf="i == 3" class="col-xs-12 col-md-12">
                            <div class="div-travel-ads text-center">
                                <h3>Ads {{ ads[0] }} goes here</h3>
                            </div>
                        </div>

                        <div *ngIf="i == 7" class="col-xs-12">
                            <div class="div-travel-ads text-center">
                                <h3>Ads {{ ads[1] }} goes here</h3>
                            </div>
                        </div>
                    </div>

                    <pagination [totalItems]="totalItems" [currentPage]="queryParams.page"
                        [pageSize]="queryParams.limit" (pageChange)="onPageChange($event)"></pagination>
                </div>
            </div>

        </div>
    </section>
</div>